import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import DropDownBox from "devextreme-react/drop-down-box";

import DataGrid, {
  Selection,
  Paging,
  FilterRow,
  Scrolling,
} from "devextreme-react/data-grid";

import "../report.css";

const gridColumns = ["text"];
const gridColumns1 = ["Entity", "Region", "Company"];

function DropDownDataGrid({
  gridDataSource,
  setValue,
  initialKeys,
}) {
  const [gridBoxValue, setGridBoxValue] = useState([]);

  const dataGrid = useRef(null);

  const getColumns = () => {
    if (!gridDataSource?.length) {
      return gridColumns;
    }

    if (Object.keys(gridDataSource[0]).length > 3) {
      return gridColumns1;
    }

    return gridColumns;
  };


  const displayExpr = () => {
    if (getColumns().length > 2) {
      return "Entity";
    }

    return "text";
  };

  const syncDataGridSelection = useCallback(
    (e) => {
      setGridBoxValue(e.value || []);

      if (e.value === null) {
        dataGrid.current?.instance()?.clearSelection();

        setValue([]);
      }
    },
    [setValue]
  );

  useEffect(() => {
    setGridBoxValue(
      Array.isArray(initialKeys)
        ? initialKeys
        : []
    );
  }, [initialKeys]);

  const handleSelectionChanged = async () => {
    if (!dataGrid.current) {
      return;
    }

    try {
      const result =
        await dataGrid.current
          .instance()
          .getSelectedRowKeys();

      setGridBoxValue(result);

      setValue(result);
    } catch (error) {
      console.error(
        "Error getting selected rows:",
        error
      );
    }
  };

  return (
    <div>
      <DropDownBox
        value={gridBoxValue}
        valueExpr="value"
        deferRendering={false}
        displayExpr={displayExpr()}
        placeholder="Select a value..."
        showClearButton={true}
        dataSource={gridDataSource}
        onValueChanged={syncDataGridSelection}
        dropDownOptions={{
          height: 350,
          maxHeight: "60vh",
        }}
        contentRender={() => (
          <div
            style={{
              height: "300px",
            }}
          >
            <DataGrid
              height="300px"
              ref={dataGrid}
              dataSource={gridDataSource}
              columns={getColumns()}
              hoverStateEnabled={true}
              keyExpr="value"
              loadPanel={null}
              onSelectionChanged={
                handleSelectionChanged
              }
            >
              <Selection
                mode="multiple"
                deferred={true}
              />

              <FilterRow
                visible={true}
              />

              <Paging
                enabled={true}
                pageSize={50}
              />

              <Scrolling
                mode="virtual"
                rowRenderingMode="virtual"
                showScrollbar="always"
                useNative={false}
                preloadEnabled={true}
              />
            </DataGrid>
          </div>
        )}
      />
    </div>
  );
}

export default DropDownDataGrid;